<template>
<input-widget :model="model" :attribute="attribute" value-field="id" :label="label"
                            :options="options"
                            display-field="${item.text}" type="select2"
              :items="clientTierOptions"/>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import InputWidget from "@/core/components/input-widget/InputWidget.vue";
import BaseModel from "@/core/components/input-widget/BaseModel";

const {mapState} = createNamespacedHelpers('global');

export default {
  name: "ClientTierSelectInputWidget",
  components: {InputWidget},
  props: {
    model: {
      type: BaseModel,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    label: {
      type: Boolean,
      default: null
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      clientTierOptions: state => state.clientTierOptions
    })
  }
}
</script>

<style scoped lang="scss">

</style>
